import React from 'react';
import NoData from './NoData';
import DataTable from './DataTable';
import { Spinner } from '@chakra-ui/react';

function RecordPanel({ filteredData, setMediaLoading, setSelectedMediaType, setSelectedItem, recordLoading }) {
    if (recordLoading) {
        return (
            <Spinner
                thickness="15px"
                speed="0.65s"
                color="green.200"
                h="240px"
                w="240px"
                mt="30%"
                ml="35%"
            />
        );
    }

    if (filteredData.length > 0) {

        return <DataTable data={filteredData} setSelectedItem={setSelectedItem} setSelectedMediaType={setSelectedMediaType} setMediaLoading={setMediaLoading}/>;
    }

    // Fallback (covers the scenario where NO RECORDS ARE RETURNED)
    return <NoData data={{heading: 'No Records to Display', subtitle: 'Choose from the search terms above to pull interaction records for a specified date range and media type(s). Matching records will be displayed here.'}}/>
}

export default RecordPanel;
